import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

export const trackSelectGender = ({ gender }: { gender?: string } = {}) => {
  ga.track('select_gender')
  amplitude.track('user_manage_personal_info', {
    ...baseWebEventProps(),
    action_name: 'manage',
    action_type: 'active',
    measurement: 'gender',
    ...(gender ? { measurement_value: gender } : {}),
    measurement_context: 'onboarding',
  })
}
